import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * @param {string} phoneNumber 
 * @param {string} defaultMessage -
 * @param {string} buttonText 
 * @param {string} className 
 * @param {ReactNode} children 
 */
const ToldosWhatsAppContact = ({
  phoneNumber,
  defaultMessage = '',
  buttonText = 'Contactar por WhatsApp',
  className = '',
  children,
  messageView = 'INSUMOS PARA ARMAR PERSINAS, TOLDOS, CORTINEROS'
}) => {
  const [message, setMessage] = useState(defaultMessage);
  
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  const handleSubmit = (e) => {
    e.preventDefault();
    window.open(whatsappUrl, '_blank');
  };

  return (
    <WhatsAppContainer className={className}>
      {children || (
        <WhatsAppForm onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="whatsapp-message">
                {messageView}
                <br/>
                Contáctanos para más información
            </Label>
          </FormGroup>
          <WhatsAppButton type="submit">
            {buttonText}
          </WhatsAppButton>
        </WhatsAppForm>
      )}
    </WhatsAppContainer>
  );
};

ToldosWhatsAppContact.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string,
  buttonText: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
const WhatsAppContainer = styled.div`
  max-width: 500px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
`;

const WhatsAppForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
  text-align: center;
`;

const WhatsAppButton = styled.button`
  background-color: #25D366;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #128C7E;
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  }
  
  &:active {
    transform: translateY(0);
  }
`;
export default ToldosWhatsAppContact;